import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(paginacao) {
  return axios.get(`prazos`, {params: paginacao})
    .then(response => response.data);
}

function buscar(busca) {
  return axios.get(`prazos/buscar?busca=${busca}`)
    .then(response => response.data);
}

function buscarPorCodigo(codigo) {
  return axios.get(`prazos/buscarCodigo?codigo=${codigo}`)
    .then(response => response.data);
}

function abrir(id) {
  return axios.get(`/prazos/${id}`)
    .then(response => response.data);
}

function salvar(prazo) {
  return axios.post('/prazos', prazo)
    .then(response => response.data);
}

function atualizar(prazo) {
  return axios.put(`/prazos/${prazo.id}`, prazo)
    .then(response => response.data)
}

function excluir(id) {
  return axios.delete(`/prazos/${id}`)
    .then(response => response.data);
}


export default {
  listar,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir
}
